<template>
  <div>
    <v-data-table
        :headers="dessertHeaders"
        :items="achievementTypeList"
        :single-expand="true"
        item-key="id"
        hide-default-footer
        show-expand
        sort-by="id"
        sort-desc
        :items-per-page="itemsPerPage"
        class="elevation-1"
        @item-expanded="getDataExpendedRow"
    >
      <template #top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>Типы достижений</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer/>
          <v-btn
            @click="setDialogAction(true)"
            :color="$store.state.achievement.primary_color" class="white--text"
          >
            Создать
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item}">
        <td :colspan="headers.length">
          <v-card elevation="0">
            <v-card-text>
              <achievement-kind-card
                :achievements-kind="achievementKindsList"
                :type-index="achievementTypeList.indexOf(item)"
                :id-type="item.id"/>
            </v-card-text>
          </v-card>
        </td>
      </template>
      <template v-slot:item.name="{ item }">
        <h5 class="text-body-1 font-weight-bold">{{item.name}}</h5>
      </template>
      <template v-slot:item.group="{ item }">
        <v-chip small>
          <v-icon small class="mr-2">
            {{item.group === 1 ? 'fa fa-graduation-cap' : 'fa fa-university'}}
          </v-icon>
          {{formattedGroup(item.group)}}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="editAchievementType(item, item.id)"
              v-bind="attrs"
              v-on="on"
            >
              fa fa-edit
            </v-icon>
          </template>
          <span>Редактировать</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              :disabled="item.delete_flag"
              @click="deleteAchievementType(item.id)"
              v-bind="attrs"
              v-on="on"
            >
              fa fa-trash
            </v-icon>
          </template>
          <span>Удалить</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click="toggleHiddenAchievementType(item.id)"
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
            >
              {{!item.is_hidden ? "fa fa-eye" : "fa-eye-slash"}}
            </v-icon>
          </template>
          <span>{{!item.is_hidden ? 'Скрыть' : 'Окрыть'}}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <form-setting-achievement/>
    <form-type-achievement/>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from "vuex";
import PrtfAchievementKindApiAdminService from "../../Services/Api/Admin/PrtfAchievementKind";
import _ from "lodash";
import store from "../../../../../stores/application/index.js.erb";
const FormSettingAchievement = () => import("../../Dialogs/FormSettingAchievement.vue")
const FormTypeAchievement = () => import("../Dialogs/FormTypeAchievement.vue")
const AchievementKindCard = () => import("../Cards/CardAdminAchievement/AchievementKindCard.vue")

export default {
  name: "AchievementSettingTab",

  data() {
    return {
      itemsPerPage: 50,
      dessertHeaders: [
        {
          text: 'Название',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Роль',
          align: 'start',
          sortable: false,
          value: 'group',
        },
        { text: 'Действия', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },

  computed: {
    ...mapState({
      achievementTypeList: state => state.achievement_type.achievementTypes,
      achievementKindsList: state => state.achievement_kind.achievementKindsList
    }),
  },

  components: {
    AchievementKindCard,
    FormSettingAchievement,
    FormTypeAchievement,
  },

  methods: {
    ...mapMutations({
      setEditMode: 'achievement_type/setEditMode',
      setEditAchievement: 'achievement_type/setEditAchievement',
      setIdType: 'achievement_type/setIdType',
      setAchievementKindsList: "achievement_kind/setAchievementKindsList",
    }),

    ...mapActions({
      setDialogAction: 'achievement_type/setDialogAction',
      deleteAchievementType: 'achievement_type/deleteAchievementType',
      toggleHiddenAchievementType: 'achievement_type/toggleHiddenAchievementType',
      getAchievementKindsList: 'achievement_kind/getAchievementKindLists',
    }),

    editAchievementType(achievement,id) {
      this.setEditAchievement(achievement);
      this.setIdType(id);
      this.setEditMode(true);
      this.setDialogAction(true);
    },

    formattedGroup(group) {
      if(group === 1) return "Обучающиеся";
      else return "Преподаватель";
    },

    isAchievementTypePresent(item) {
      return item.achievementKindsList.length > 0;
    },

    async getDataExpendedRow(payload) {
      if (!payload.value) return this.setAchievementKindsList([]);
      await this.getAchievementKindsList(payload.item.id);
    },

  }
}
</script>

<style scoped>
.v-tooltip__content {
  opacity: 1 !important;
  padding: 0 !important;
}

.v-data-table >>> .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}
</style>